import { Container } from "@mui/material";
import React from "react";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import { styled } from "@mui/material/styles";
import styles from "../Style/Modules/contactUs.module.css";
import "../Style/Theme/index.css";
import configData from "../Config/index";
import { CONSTANTS } from "../../src/utils/constant";

import {
  Box,
  Typography,
  Grid,
  Button,
  Radio,
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function ContactUs() {
  return (
    <>
      <Container className="container_Th">
        <Header showBar={true} step={1} showContactUs={false} />
        {/* <IntroCard
          title="Contact Us"
          subtitle="Reach us at"
          img="/assets/terms.svg"
        /> */}
        {/* <LoginFormPay /> */}
        {/* <h4>•	Reach us at:</h4> */}
        <Box className={styles.contactUsGrid}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Item
                className="grid_Th"
                // className={`${styles.contactUsItem} grid_Th`}
                style={{
                  // background: "#498fff1a",
                  fontSize: "14px",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                Corporate Office
              </Item>

              <Item
                style={{
                  background: "",
                  fontSize: "12.8px",
                }}
              >
                1004/5, 10th Floor, C-Wing, One BKC, C-66, G- Block, Bandra
                Kurla Complex, Bandra East, Mumbai 400 051, Maharashtra, India
                <br />
                Tel : 1800 210 0444
                <br />
                Mail :{" "}
                <a href="mailto:customercare.tcpl@tyger.in">
                  {" "}
                  customercare.tcpl@tyger.in
                </a>
              </Item>
            </Grid>
            <Grid item xs={6}>
              <Item
                className="grid_Th"
                style={{
                  // background: "#498fff1a",
                  fontSize: "14px",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                Registered Office
              </Item>
              <Item
                style={{
                  background: "",
                  fontSize: "14.4px",
                }}
              >
                Adani House, 56 Shrimali Society Navrangpura Ahmedabad 380009,
                Gujarat, India For more details, please visit our Company
                website:{" "}
                <a href="https://www.adanicapital.in/" target={"_blank"}>
                  https://www.adanicapital.in/
                </a>
              </Item>
            </Grid>

            <Grid item xs={12}>
              <Item
                className="grid_Th"
                style={{
                  // background: "#498fff1a",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              ></Item>
              <Item
                style={{
                  background: "",
                  fontSize: "12.8px",
                }}
              >
                In case of any grievances, please refer
                <a
                  style={{ color: "blue", textDecorationLine: "underline" }}
                  // href="https://www.adanicapital.in/-/media/Project/AdaniCapital/Download/Policies_Practices/Grievance-Redressal-Policy---ACPL.pdf"
                  href={`${configData?.GETFILE}Grievance Redressal Policy - TCPL.pdf`}
                  target={"_blank"}
                >
                  {" "}
                  Grievance Redressal Policy
                </a>{" "}
                and
                <a
                  style={{ color: "blue", textDecorationLine: "underline" }}
                  // href="https://www.adanicapital.in/-/media/Project/AdaniCapital/Download/Policies_Practices/Salient-Features---RBI-Integrated-Ombudsman-Scheme_ACPL.pdf"
                  href={`${configData?.GETFILE}Salient Features - RBI Integrated Ombudsman Scheme_TCPL.pdf`}
                  target={"_blank"}
                >
                  {" "}
                  Salient Features – RBI Integrated Ombudsman Scheme_ACPL
                </a>{" "}
                or please reach out to
                <br />
                <b>Nodal grievance redressal officer:</b>
                <br />
                Anurag Pandey Head - Customer Engagement & Experience
                <br />
                Adani Capital Pvt. Ltd. 1004/5, C-Wing, One BKC, C-66, G Block,
                Bandra Kurla Complex, Mumbai-400051
                <br />
                <a href="mailto:escalations.tcpl@tyger.in">
                  {" "}
                  escalations.tcpl@tyger.in{" "}
                </a>
                022-62827068
                <br />
                Timings: 10:00 AM to 5:00 PM (Monday to Friday)
              </Item>
            </Grid>

            <Grid item xs={12}>
              <Item
                className="grid_Th"
                style={{
                  // background: "#498fff1a",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
              ></Item>
              <Item
                style={{
                  background: "",
                  fontSize: "12.8px",
                }}
              >
                Please refer to our{" "}
                <a
                  style={{ color: "blue", textDecorationLine: "underline" }}
                  href={`${configData?.GETFILE}PRIVACY_TC [ContactUs].pdf`}
                  // href="https://micro.adanicapital.in/cdn/img/PRIVACY_TC.pdf"
                  target={"_blank"}
                >
                  Privacy Policy{" "}
                </a>
                . In case you want the digital lending application to delete or
                forget your data from its records that is no longer necessary
                for the purpose for which it was obtained and processed, please
                mail your request at{" "}
                <a href="mailto:sales.scf@tyger.in">sales.scf@tyger.in </a>.
                Please note that the option to delete or forget shall not be
                available in case the said data is required to be maintained or
                stored as per regulatory/statutory guidelines or in public
                interest .
              </Item>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
}
